import React from 'react';
import { findDOMNode } from 'react-dom';
import autobind from 'autobind-decorator';
import _ from 'underscore';
import Base from 'client/components/base';

export default class Image extends Base {
  constructor(props) {
    super(props);

    this.state = {
      width: this.props.width,
      loaded: false,
    };
  }

  componentDidMount() {
    if (!this.state.width) {
      let element = findDOMNode(this);
      if (element) {
        this.setState({
          width: element.getBoundingClientRect().width,
        });
      }
    }
  }

  @autobind
  onLoad() {
    this.setState({
      loaded: true,
    });
  }

  render() {
    if (this.state.width) {
      let model = this.props.model;
      let width = this.state.width;
      let style = this.state.loaded
        ? this.props.style
        : _.extend(
            {
              minHeight: this.state.width,
            },
            this.props.style
          );

      return (
        <img
          className={this.props.className}
          style={style}
          src={`${this.getImageApiUrl(model, this.state.width, this.props)}`}
          onLoad={this.onLoad}
        />
      );
    } else {
      // put out an auto-adjusting (hopefully) DOM that we can
      // measure the first frame to get the correct width (and height)
      return (
        <div className={this.props.className} style={{ width: '100%' }}>
          <div style={{ marginTop: '100%' }} />
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/common/image/image.es6